/**
 * Textarea with Character Count Renderer
 * Features: character counter, maxLength enforcement
 */
import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import type { FieldRenderer } from '@/MyCode/core';

export const renderTextareaWithCharacterLeft: FieldRenderer = ({
    field,
    value,
    hasError,
    handleChange,
    isRequired
}) => {
    const maxLength = field.maxLength || 500;
    const characterCount = (value || '').length;
    const charactersLeft = maxLength - characterCount;

    return (
        <div className="space-y-2">
            <Label htmlFor={field.name}>
                {field.label}
                {isRequired && <span className="text-destructive ml-1">*</span>}
            </Label>
            <Textarea
                id={field.name}
                value={value || ''}
                maxLength={maxLength}
                onChange={(e) => handleChange(field.name, e.target.value)}
                placeholder={field.placeholder}
                className={hasError ? 'border-destructive' : ''}
                aria-describedby={`${field.name}-description`}
            />
            <p
                id={`${field.name}-description`}
                className="mt-2 text-right text-xs text-muted-foreground"
                role="status"
                aria-live="polite"
            >
                <span className="tabular-nums">{charactersLeft}</span>{" "}
                characters left
            </p>
        </div>
    );
};

export default renderTextareaWithCharacterLeft;